import {
  validateISChanged,
  validateVigencyChange,
  validateISGreaterThanApoliceIS,
  validateVigencyEndDateGreaterThanCurrentApolice,
} from "@/libs/endorsement";

export const EndorsementForm = {
  step: "InformacoesDaApolice",
  state: {
    dialogResumoProposta: false,
    submittingEndorsementProposal: false,
  },
  validate(delegate) {
    let res = delegate.isISSelected || delegate.isVigenciaSelected;
    if (!res) return false;

    if (delegate.isISSelected) {
      res &&=
        validateISChanged(delegate.policy, delegate.importanciaSeguradaModel) &&
        validateISGreaterThanApoliceIS(
          delegate.policy,
          delegate.importanciaSeguradaModel.valor
        );
    }

    if (delegate.isVigenciaSelected) {
      res &&=
        validateVigencyChange(delegate.policy, delegate.vigenciaModel) &&
        validateVigencyEndDateGreaterThanCurrentApolice(
          delegate.policy,
          delegate.vigenciaModel.fim_vigencia
        );
    }

    return res;
  },
  async nextStep(delegate) {
    return { step: "ViewingResume" };
  },
  async previousStep(delegate) {
    return { step: "InformacoesDaApolice" };
  },
  getAction() {
    return;
  },
};

export const ViewingResume = {
  step: "InformacoesDaApolice",
  state: {
    dialogResumoProposta: true,
    submittingEndorsementProposal: false,
  },
  validate(delegate) {
    return true;
  },
  async nextStep(delegate) {
    return { step: "SubmittingProposal" };
  },
  async previousStep(delegate) {
    return { step: "EndorsementForm" };
  },
  getAction() {
    return "makeEndorsement";
  },
};

export const SubmittingProposal = {
  step: "InformacoesDaApolice",
  state: {
    dialogResumoProposta: false,
    submittingEndorsementProposal: true,
  },
  validate(delegate) {
    return true;
  },
  async nextStep(delegate) {
    return { step: "CommissionForm" };
  },
  async previousStep(delegate) {
    return { step: "EndorsementForm" };
  },
  getAction() {
    return "getPremium";
  },
};

export const CommissionForm = {
  step: "PremioEComissao",
  state: {
    dialogResumoProposta: false,
    submittingEndorsementProposal: false,
  },
  validate(delegate) {
    return true;
  },
  async nextStep(delegate) {
    return { step: "CommissionForm" };
  },
  async previousStep(delegate) {
    return { step: "EndorsementForm" };
  },
  getAction() {
    return "emitEndorsement";
  },
};

export const steps = {
  EndorsementForm,
  ViewingResume,
  SubmittingProposal,
  CommissionForm,
};

export default {
  data() {
    return { step: EndorsementForm };
  },

  computed: {
    currentStep() {
      return this.Steps[this.step.step];
    },
    currentStepData() {
      return this.Steps[this.step.step].step;
    },
  },

  methods: {
    changeStep(step) {
      this.step = steps[step.step];
      this.resetScroll();
    },

    stepValidation() {
      return this.step.validate(this);
    },

    async previousStep() {
      const step = await this.step.previousStep(this);
      this.changeStep(step);
    },

    async nextStep() {
      const step = await this.step.nextStep(this);
      this.changeStep(step);
    },

    execStepAction() {
      const action = this.step.getAction();
      action && this[action]();
      return action;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/EndorsementStepController.js